import { render } from "./ListeCompagniePage.vue?vue&type=template&id=382a0574&ts=true"
import script from "./ListeCompagniePage.vue?vue&type=script&lang=ts"
export * from "./ListeCompagniePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__